import { Box, Stack, Typography } from '@mui/material'
import Link from 'next/link'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { RiskLevelOption, RiskScoreMethodology } from '@omnea-app/risks/risksFrontendClient'

type Props = {
  probability: RiskLevelOption
  impact: RiskLevelOption
  riskScoreMethodology: RiskScoreMethodology
}

const RiskLevelLine = ({ label, name, score }: { label: string; name: string; score: number }) => (
  <Box display="flex" width="100%">
    <Typography variant="small-regular" color="text.default" sx={{ flex: '0 0 50%' }}>{`${label}:`}</Typography>
    <Typography variant="small-medium" color="text.default" sx={{ flex: '0 0 50%' }}>{`${score} – ${name}`}</Typography>
  </Box>
)

export const RiskChipTooltipScore: FC<Props> = ({ riskScoreMethodology, impact, probability }) => {
  const { t } = useTranslation('risks')
  const { user } = useAuthenticatedUser()

  return (
    <>
      <Stack gap={2}>
        <RiskLevelLine score={impact.score} name={impact.name} label={t('score.impact')} />
        <RiskLevelLine score={probability.score} name={probability.name} label={t('score.probability')} />
      </Stack>
      {user.isAdmin && user.hasConfigPermissions && (
        <Typography variant="small-regular" color="text.muted">
          {t(`chip-tooltip.score.methodology.${riskScoreMethodology}`)}{' '}
          <Link href="/risks/settings">
            <Typography color="primary" variant="small-regular">
              {t('chip-tooltip.score.methodology.cta')}
            </Typography>
          </Link>
          .
        </Typography>
      )}
    </>
  )
}
